app.service('sufficientOutletProductList', function(
	modal,
	lazyLoad,
	pageConfig,
	productCardConfig,
	sufficientOutletCategory
) {
	let $sufficientOutletProductList;
	let config;

	function loadProductList(data) {
		return $.ajax({
			url: '/outlet-product-loader.ltr',
			data
		});
	}

	function handleLoadMoreProductsClick() {
		const data = {
			productId: config.id,
			outletCategoryId: $(this).data('outlet-category-id')
		};

		$sufficientOutletProductList.addClass('loading');

		loadProductList(data)
			.then(appendProducts)
			.fail(showListLoadingErrorMessage)
			.always(() => {
				$sufficientOutletProductList.removeClass('loading');
				lazyLoad.update();
				setProductInCartButton();
			});
	}

	function appendProducts(html) {
		$sufficientOutletProductList.html(html);
	}

	function showListLoadingErrorMessage() {
		modal.alert('Błąd pobierania listy produktów.');
	}

	function handleCheckProductClick() {
		const outletCategoryId = $(this).closest('.outlet-category-item').data('outlet-product-id');
		const position = $(this).index();

		sufficientOutletCategory.showIndividualOffer(outletCategoryId, position);
	}

	function setProductInCartButton() {
		const huCodesInBasket = getHuCodesInBasket();
		const $checkProductButtons = $sufficientOutletProductList.find(
			'.check-product'
		);

		$checkProductButtons.each((i, button) => {
			const huCode = '' + $(button).data('hu-code');

			if (huCodesInBasket.indexOf(huCode) > -1) {
				$(button)
					.addClass('is-active')
					.text('W koszyku');
			} else {
				$(button)
					.removeClass('is-active')
					.text('Obejrzyj i kup');
			}
		});
	}

	function getHuCodesInBasket() {
		const { items } = pageConfig.getData('basket');
		return items.map(item => item.huCode);
	}

	function setEvents($modal) {
		$($modal)
			.on('click', '.js-load-more-outlet-products', handleLoadMoreProductsClick)
			.on('click', '.js-check-product', handleCheckProductClick)
	}

	function setElements() {
		$sufficientOutletProductList = $('.sufficient-outlet-list');
	}

	function init($modal) {
		config = productCardConfig.getData();
		setElements();
		setEvents($modal);
		setProductInCartButton();
	}

	return {
		init
	};
});
